module.exports = __webpack_public_path__ + "img/optionsmenu.31c62791.png";